// extracted by mini-css-extract-plugin
module.exports = {"form":"AuthForm_form__15rFg","title":"AuthForm_title__t-oVU","error":"AuthForm_error__3cNUn","btn":"AuthForm_btn__28EJ8"};